module.exports = __webpack_public_path__ + "img/art-work-icon13.8b578b76.png";